import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import NoDataFound from '../../Component/Common/NoDataFound';
import StatusButton from '../../Component/Common/StatusButton';
import { standardDateFormat } from '../../lib/standardDateFormat';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonPagination from '../../Component/Common/CommonPagination';
import { currencyOptions, useCommonStyles } from '../../utils';
import { Box, Button, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import AddUpdatePurchaseEntry from '../../Component/PurchaseEntry/AddUpdatePurchaseEntry';
import { deletePurchaseEntry, getPurchaseEntryById, getPurchaseEntrys, getRemainingQuantity, updateRemainingQuantityByPONumber } from '../../Redux/Actions/PurchaseEntry';
import { useConfirm } from 'material-ui-confirm';
import { useAppSelector } from '../../Redux/app/hooks';
import CommonSearchField from '../../Component/Common/CommonSearchField';

const PurchaseEntry = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [selectedItem, setSelectedItem] = useState({});
    const [listData, setListData] = useState({});
    const [isOpenAddUpdatePurchaseEntry, setIsOpenAddUpdatePurchaseEntry] = useState(false);
    const [data, setData] = useState({ currency: { name: "INR", symbol: "₹" } })
    const [purchaseOrderList, setPurchaseOrderList] = useState([])
    const [remainingQuantityData, setRemainingQuantityData] = useState([])
    const [searchValue, setSearchValue] = useState('');
    const [sortConfig, setSortConfig] = useState(null); // null | true | false
    const [activeSortColumn, setActiveSortColumn] = useState(null);

    // =============== Handler ===============
    let PerPage = 10
    const tabelHeader = ["SR.", "Purchase Entry No", "PO NUMBER", "VENDOR NAME", "Invoice Number", "DELIVERY DATE", "RATE PER UNIT", "Supply Quantity", "Action"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    const handleChangePage = (e, p) => {
        setPage(p);
    };
    // ============= get Inventories API =============
    const _getPurchaseEntry = async (p) => {
        setFullPageLoader(true);
        let response;
        let body;
        if (sortConfig == true || sortConfig == false) {
            body = {
                "limit": PerPage,
                "page": p ? p : page,
                "search": searchValue,
                "sortBy": activeSortColumn,
                "sortOrder": sortConfig
            }
        } else {
            body = {
                "limit": PerPage,
                "page": p ? p : page,
                "search": searchValue,
            }
        }
        response = await dispatch(getPurchaseEntrys(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getPurchaseEntryById = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getPurchaseEntryById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response
                setSelectedItem(response?.payload?.data?.response)
                setIsOpenAddUpdatePurchaseEntry(true)
                const findCurrency = currencyOptions?.find((ele) => ele?.name == res?.moneyType)
                setData({
                    ...data,
                    "vendor": { name: res?.vendorName },
                    "poNumber": { poNumber: res?.poNumber, category: res?.vendorDetail?.category },
                    "invoiceNumber": res?.invoiceNumber,
                    "grnNumber": res?.GRNNUmber,
                    "testCertificate": res?.testCertificateDocument,
                    "currency": findCurrency,
                    "invoiceDate": res.invoiceDate,
                    "deliveryDate": res.deliveryDate,
                    "otherCharges": res?.otherCharges,
                    "lotNumber": { lotNumber: res?.lotNumber },
                    "total": res?.totalAmount,
                    "remarks": res?.description,
                    "unitType": res?.unitType,
                    "purchaseEntryNumber": res?.purchaseEntryNumber,
                    "advanceLicenseItems": res?.advanceLicenseItems,
                    "advanceLicenseId": res?.advanceLicenseId
                })
                _updateRemainingQuantityByPONumber(res)
                // setPurchaseOrderList(res?.purchaseOrder)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };


    // ============= get Remaining Quantity API =============
    const _updateRemainingQuantityByPONumber = async (getListData) => {
        setFullPageLoader(true);
        let response;
        let body = {
            poNumber: getListData?.poNumber,
            _id: getListData?._id
        }
        response = await dispatch(updateRemainingQuantityByPONumber(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const finalListData = getListData?.purchaseOrder
                setPurchaseOrderList(finalListData)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Delete Inventory Field API =============
    const _deletePurchaseEntry = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(deletePurchaseEntry(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                _getPurchaseEntry();
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getPurchaseEntry();
        } else {
            _getPurchaseEntry();
        }
    }, [page, searchValue])
    useEffect(() => {
        setPage(1);
    }, [searchValue]);

    const handleSort = (column) => {
        setActiveSortColumn(column);

        setSortConfig(prev => {
            const next =
                activeSortColumn !== column
                    ? true
                    : prev === null
                        ? true
                        : !prev;
            return next;
        });
    };

    useEffect(() => {
        if (sortConfig === true || sortConfig === false) {
            _getPurchaseEntry();
        }
    }, [sortConfig, activeSortColumn]);
    return (
        <>
            {isOpenAddUpdatePurchaseEntry ?
                <AddUpdatePurchaseEntry setSearchValue={setSearchValue} setRemainingQuantityData={setRemainingQuantityData} remainingQuantityData={remainingQuantityData} setIsOpenAddUpdatePurchaseEntry={setIsOpenAddUpdatePurchaseEntry} purchaseOrderList={purchaseOrderList} setPurchaseOrderList={setPurchaseOrderList} setData={setData} data={data} selectedItem={selectedItem} setSelectedItem={setSelectedItem} _getPurchaseEntry={_getPurchaseEntry} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Purchase Entry List</Typography>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["PO Number", 'Vendor Name', 'Item Name']} />
                            {/* <Button className={classes.cancelButton} startIcon={<FilterListIcon />}>Filters </Button> */}
                            {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddUpdatePurchaseEntry(true)}>Create Purchase Entry</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>

                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => {
                                                const isSortable =
                                                    ele === "Purchase Entry No" || ele === "PO NUMBER";

                                                const isActive = activeSortColumn === ele;

                                                return (
                                                    <StyledTableCell key={ele}>
                                                        {ele}

                                                        {isSortable && (
                                                            <span
                                                                style={{ cursor: "pointer", marginLeft: 6 }}
                                                                onClick={() => handleSort(ele)}
                                                            >
                                                                {isActive
                                                                    ? sortConfig === null
                                                                        ? "⬍"
                                                                        : sortConfig
                                                                            ? "⬆"
                                                                            : "⬇"
                                                                    : "⬍"}
                                                            </span>
                                                        )}
                                                    </StyledTableCell>
                                                );
                                            })}
                                        </StyledTableRow>


                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ?
                                            listData?.response?.map((row, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow>
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row.purchaseEntryNumber ? row.purchaseEntryNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.poNumber ? row.poNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.vendorName ? row.vendorName : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.invoiceNumber ? row?.invoiceNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.deliveryDate && standardDateFormat(row?.deliveryDate)}</StyledTableCell>
                                                        <StyledTableCell>
                                                            {(
                                                                row?.purchaseOrder?.reduce(
                                                                    (acc, item) => acc + (item?.ratePerUnit || 0),
                                                                    0
                                                                ) || 0
                                                            ).toFixed(3)}
                                                        </StyledTableCell>
                                                        <StyledTableCell> {row?.purchaseOrder?.reduce((acc, item) => acc + (item?.supplyQuantity || 0), 0)} {row?.unitType}</StyledTableCell>

                                                        <StyledTableCell>
                                                            <Box display={"flex"} gap={1}>
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"edit"} disabled={row.status === 1} onClick={() => _getPurchaseEntryById(row?._id)} />
                                                                }
                                                                {/* {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"delete"} disabled={row.status === 1}
                                                                        onClick={(e) => {
                                                                            confirmDialogue({
                                                                                title: `Are you sure you want to delete?`,
                                                                            }).then(() => {
                                                                                _deletePurchaseEntry(row?._id)
                                                                            }).catch((err) => { console.error(err) });
                                                                        }}
                                                                    />
                                                                } */}
                                                            </Box>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            ))
                                            :
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>

                </Grid>
            }
        </>
    )
}

export default PurchaseEntry